var p = { exports: {} };
export {
  p as __module
};
//# sourceMappingURL=index.es.js.map
